import React, { FC } from 'react';
import { Button, Icon, Typography } from '@packages/ui/shared';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    container: {
        minWidth: '120px',
    },
});

interface FiltersComponentProps {
    emptyFilters: { [key: string]: string | string[] | any };
    filtersCount: number;
    setFilters: (filters: any) => void;
    toggleTechlineFilters: () => void;
}

export const FiltersComponent: FC<FiltersComponentProps> = ({
    filtersCount,
    toggleTechlineFilters,
    setFilters,
    emptyFilters,
}) => {
    const classes = useStyles();

    return (
        <div className={`d-flex flex-row justify-content-between align-items-center ${classes.container}`}>
            <div className="d-flex flex-row align-items-center">
                {filtersCount ? (
                    <div className="d-flex flex-row align-items-center justify-content-between">
                        <Button
                            active={false}
                            variant="ghost-blue"
                            iconLeft={<Icon color="blueOne" name="filter-list" />}
                            onPress={toggleTechlineFilters}
                        >
                            <Typography variant="h5" color="blueOne">
                                Applied filters ({filtersCount})
                            </Typography>
                        </Button>
                        <div className="ml-5">
                            <Button variant="ghost-blue" onPress={() => setFilters(emptyFilters)}>
                                Clear all
                            </Button>
                        </div>
                    </div>
                ) : (
                    <Button
                        active={false}
                        variant="ghost-blue"
                        iconLeft={<Icon color="blueOne" name="filter-list" />}
                        onPress={toggleTechlineFilters}
                    >
                        More Filters
                    </Button>
                )}
            </div>
        </div>
    );
};
